import * as React from 'react';
import { Text, Headline, InfoBox } from '@oneaudi/unified-web-components';
import { useI18n } from '@oneaudi/i18n-context';

import { TyreLabelItem } from './TyreLabelItem';
import {
  SYS_SPACE_RELATIVE_BP_SM_3_XL,
  SYS_SPACE_RELATIVE_BP_SM_SM,
} from '@oneaudi/unified-web-common';
import { HeadlineAndInfoContainer, HeadlinePanel, InfoPanel, TyreLabelListStyled } from './styles';

export interface AudiFeatureAppTyreLabelTyreLabelItem {
  tyreLabelUrl: string;
  productSheetUrl: string;
}

interface TyreLabelProps {
  tyreLabels: {
    mainTyreLabels: Array<AudiFeatureAppTyreLabelTyreLabelItem>;
    additionalTyreLabels: Array<AudiFeatureAppTyreLabelTyreLabelItem>;
  };
}

export const TyreLabel: React.FC<TyreLabelProps> = ({ tyreLabels }) => {
  const headline = useI18n({
    id: 'fa.audi-feature-app-tyre-label.tyre-label-headline',
    defaultMessage: '',
  });
  const infoLabel = useI18n({
    id: 'nemo.ui.sc.tyrelabel.info.label',
    defaultMessage: '',
  });
  const infoText = useI18n({
    id: 'fa.audi-feature-app-tyre-label.tyre-label-info-note',
    defaultMessage: '',
  });
  const mainTyreHeadline = useI18n({
    id: 'nemo.ui.sc.tyrelabel.maintyres.label',
    defaultMessage: '',
  });
  const additionalTyreHeadline = useI18n({
    id: 'nemo.ui.sc.tyrelabel.additionaltyres.label',
    defaultMessage: '',
  });

  return (
    <>
      <HeadlineAndInfoContainer>
        {headline && (
          <HeadlinePanel>
            <Headline
              tag="h3"
              variant={{ type: 'headline', order: '3', weight: 'normal' }}
              data-testid="tyreLabelLayerHeadline"
            >
              {headline}
            </Headline>
          </HeadlinePanel>
        )}
        <InfoPanel>
          {tyreLabels.additionalTyreLabels.length > 0 && (
            <>
              <Text
                variant={{ type: 'copy', order: '3', style: 'normal' }}
                margin={[SYS_SPACE_RELATIVE_BP_SM_3_XL, 0, 0, 0]}
              >
                {additionalTyreHeadline}
              </Text>
              <TyreLabelListStyled>
                {tyreLabels.additionalTyreLabels.map((item) => {
                  return (
                    <TyreLabelItem
                      data-testid="AdditionalTyreLabel"
                      tyreLabelItem={item}
                      key={item.tyreLabelUrl}
                    />
                  );
                })}
              </TyreLabelListStyled>
            </>
          )}
          {tyreLabels.mainTyreLabels.length > 0 && (
            <>
              <Text
                variant={{ type: 'copy', order: '2', style: 'normal' }}
                margin={[SYS_SPACE_RELATIVE_BP_SM_3_XL, 0, 0, 0]}
              >
                {mainTyreHeadline}
              </Text>
              <TyreLabelListStyled>
                {tyreLabels.mainTyreLabels.map((item) => {
                  return (
                    <TyreLabelItem
                      data-testid="MainTyreLabel"
                      tyreLabelItem={item}
                      key={item.tyreLabelUrl}
                    />
                  );
                })}
              </TyreLabelListStyled>
            </>
          )}
          {infoLabel && (
            <Text
              variant={{ type: 'copy', order: '2', style: 'normal' }}
              margin={[SYS_SPACE_RELATIVE_BP_SM_3_XL, 0, 0, 0]}
              data-testid="TyreLabelInfo"
            >
              {infoLabel}
            </Text>
          )}
          {infoText && (
            <InfoBox
              copy={infoText}
              icon="info-circle"
              margin={[SYS_SPACE_RELATIVE_BP_SM_SM, 0, 0, 0]}
            />
          )}
        </InfoPanel>
      </HeadlineAndInfoContainer>
    </>
  );
};
